import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { TabPanel, TabView } from "primereact/tabview";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { Api } from "../../../services/api";
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FilterMatchMode, FilterOperator } from "primereact/api";
const History = () => {
    const toast = useRef(null);
    const navigate = useNavigate();
    const [activeIndex, setActiveIndex] = useState(0);
    const [projects, setProjects] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    

    /** search Filtter function Start */
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            project_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            first_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            last_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            ProjectType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

        });
        setGlobalFilterValue('');
    };
    /** search Filtter function End */

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-between m-2">
            <div></div>
            <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field"
                    type="search"
                    value={globalFilterValue} onChange={onGlobalFilterChange}
                    // onChange={(e) => searchproject(e.target.value)}
                    placeholder="Search..."
                />
            </span>
        </div>
    );


    useEffect(() => {
        getProjectDetails();
        initFilters();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);
    const getProjectDetails = () => {
        // fetch.

        fetch(Api.API_BASE_URL + 'all-template/get-archive-all-project', {
            // fetch(Api.API_BASE_URL + 'pm-template/get', {
            method: "GET",


        })
            .then((response) => response.json())
            .then((response) => {

                setProjects(response.result);


            })
            .catch((error) => {
                // setIsLoading(false);
                console.error("Error:", error);
            });
    }

  

    const edit = (id, projectId) => {
        navigate('/archive-history-templates/' + projectId)
    }

    const onSelectionChange = (e) => {
        console.log("Selected Product", e.value)
        setSelectedProduct(e.value)
        edit(e.value.id, e.value.projectId);
    }
    return (
        <><Toast ref={toast} />
            <ConfirmDialog />
         
            <div className="pagination-datable-height">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                    <TabPanel header="" className="p-2 pb-2" >
                        <div className=" m-0" style={{ width: "100%" }} >
                            <DataTable value={projects} paginator rows={12} dataKey="id" selection={selectedProduct} onSelectionChange={(e) => onSelectionChange(e)} selectionMode="single" header={header} filters={filters} globalFilterFields={['project_name', 'ProjectType', 'first_name', 'last_name']}  >

                                {/* <Column field="project_name" header="Project Name" className="h-3rem" ></Column> */}
                                <Column field="project_name" header="Project Name"  ></Column>
                                <Column field="ProjectType" header="Project Type" ></Column>
                                <Column field="pM" header="Project Manager" body={(e) => <span>{e.first_name} {e.last_name}</span>}></Column>

                            </DataTable>
                        </div>
                    </TabPanel>



                </TabView>
            </div>


        </>
    )
}

export default History;